import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-196524be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text--center black__base__color" }
const _hoisted_2 = {
  key: 0,
  class: "text--center"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "forgot-title gray__base__color" }
const _hoisted_5 = { class: "forgot-description gray__base__color" }
const _hoisted_6 = { class: "text--center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "justify-content-login" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, { class: "box-card max-w-login" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("accountSettings.resetPassword")), 1),
          (_ctx.eventData.themeSettings.logoURL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("img", {
                  style: {"width":"200px","height":"200px"},
                  src: _ctx.eventData.themeSettings.logoURL,
                  alt: "event photo"
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("recoveryPassword.subtitle")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("recoveryPassword.description")), 1)
            ])
          ]),
          _createVNode(_component_el_form, {
            model: _ctx.form,
            ref: "passwordform"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "email.value",
                rules: _ctx.form.email.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, _mergeProps({
                    class: "forgot-input",
                    size: "large",
                    "data-test": "email",
                    "prefix-icon": "el-icon-user-solid",
                    placeholder: _ctx.$t('recoveryPassword.emailLabel')
                  }, _ctx.form.email.props, {
                    modelValue: _ctx.form.email.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email.value) = $event)),
                    onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.resetPassword(_ctx.form.email.value)), ["enter"]))
                  }), null, 16, ["placeholder", "modelValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_button, {
              class: "secondary__color__button",
              type: "primary",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resetPassword(_ctx.form.email.value)), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("recoveryPassword.resetPasswordButton")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}